import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import i18n, { ensureLang, isLang } from "@/i18n";

export const Route = createFileRoute("/$lang")({
  beforeLoad: async ({ params }) => {
    if (!isLang(params.lang) || params.lang === "nl") {
      throw redirect({ to: "/" });
    }
    // Sync i18n during SSR AND client navigation, before any component
    // renders. Resources are bundled synchronously, so changeLanguage is
    // effectively synchronous — the fire-and-forget promise is fine.
    await ensureLang(params.lang);
    if (i18n.language !== params.lang) {
      void i18n.changeLanguage(params.lang);
    }
  },
  component: LangLayout,
});

function LangLayout() {
  return <Outlet />;
}
